export const MM_PER_IN = 25.4;
export const PT_PER_IN = 72;
export const MM_PER_PT = MM_PER_IN / PT_PER_IN;
export const PT_PER_MM = PT_PER_IN / MM_PER_IN;

export const clamp = (v: number, lo: number, hi: number): number =>
  Math.max(lo, Math.min(hi, v));

export const fmt = (n: number, p = 1): string =>
  Number(n).toFixed(p).replace(/\.?0+$/, "");
